import { PumpSuspendReason } from "@tandemdiabetes/sugarmate-api-react-client"
import styles from "./PumpSuspensionEventModal.module.scss"

import type { PumpSuspensionEventProps } from "./PumpSuspensionEventProps"
import { usePolyglot } from "src/contexts"

const prefix = "components.activity_summary."

export function PumpSuspendReasonDisplay(props: PumpSuspensionEventProps) {
  const { userEvent } = props
  const polyglot = usePolyglot()

  let suspendReason: string | undefined
  switch (userEvent.pump_suspension.suspend_reason) {
    case PumpSuspendReason.Alarm:
      suspendReason = polyglot.t(`${prefix}message.pump_suspension.alarm`)
      break
    case PumpSuspendReason.PumpMalfunction:
      suspendReason = polyglot.t(
        `${prefix}message.pump_suspension.malfunction`,
      )
      break
    case PumpSuspendReason.UserAborted:
      suspendReason = polyglot.t(
        `${prefix}message.pump_suspension.stopped_by_user`,
      )
      break
    default:
      return null
  }

  return (
    <>
      <div className={styles.row}>
        <span className={styles.textLargeBold}>
          {suspendReason}
        </span>
      </div>
      <div className={styles.separator} />
    </>
  )
}
